import { memo } from "react";

import {
  type Maybe,
  type Image,
} from "@shopify/hydrogen-react/storefront-api-types";

import { useSectionSettings } from "@sections/Root/SectionSettingsContext";
import { type CollectionSectionSettings } from "@tablescape/state";

import { CollectionHeroView } from "./CollectionHero.view";

type Props = {
  breadcrumbsLabel: string;
  description?: Maybe<string>;
  heroImage?: Maybe<Image>;
  homeLabel: string;
  title?: Maybe<string>;
};
const CollectionHeroBase = ({
  breadcrumbsLabel,
  description,
  heroImage,
  homeLabel,
  title,
}: Props) => {
  const {
    collectionHero: {
      description: descriptionFromSettings,
      heroImage: heroImageFromSettings,
      title: titleFromSettings,
    },
  } = useSectionSettings<CollectionSectionSettings>();

  return (
    <CollectionHeroView
      breadcrumbsLabel={breadcrumbsLabel}
      description={description ?? descriptionFromSettings}
      heroImage={heroImage ?? heroImageFromSettings}
      homeLabel={homeLabel}
      title={title ?? titleFromSettings}
    />
  );
};

export const CollectionHero = memo(CollectionHeroBase);
